var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ChatsCircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.13127 8.79459C1.57087 7.85044 1.37444 6.73418 1.57888 5.65545C1.78332 4.57671 2.37457 3.60973 3.24157 2.93611C4.10857 2.26248 5.19168 1.92856 6.28748 1.99707C7.38327 2.06557 8.41636 2.53178 9.19272 3.30814C9.96908 4.08449 10.4353 5.11758 10.5038 6.21338C10.5723 7.30918 10.2384 8.39229 9.56475 9.25929C8.89113 10.1263 7.92414 10.7175 6.84541 10.922C5.76668 11.1264 4.65041 10.93 3.70627 10.3696L2.15002 10.8133C2.0859 10.8314 2.01813 10.832 1.95369 10.8151C1.88925 10.7983 1.83045 10.7646 1.78336 10.7175C1.73626 10.6704 1.70255 10.6116 1.68571 10.5472C1.66887 10.4827 1.66949 10.415 1.68752 10.3508L2.13127 8.79459Z",
    stroke: "#0E46C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.75623 10.9934C5.9765 11.6214 6.33353 12.1927 6.80151 12.6659C7.2695 13.1391 7.83675 13.5025 8.46229 13.7297C9.08784 13.957 9.75605 14.0424 10.4186 13.9799C11.0813 13.9174 11.7217 13.7086 12.2937 13.3684V13.3684L13.85 13.8121C13.9141 13.8301 13.9819 13.8308 14.0463 13.8139C14.1107 13.7971 14.1695 13.7634 14.2166 13.7163C14.2637 13.6692 14.2974 13.6104 14.3143 13.5459C14.3311 13.4815 14.3305 13.4137 14.3125 13.3496L13.8687 11.7934C14.2649 11.1284 14.4826 10.3723 14.5007 9.59847C14.5188 8.82463 14.3367 8.05923 13.972 7.37645C13.6073 6.69367 13.0725 6.11666 12.4193 5.70133C11.7661 5.286 11.0167 5.04644 10.2437 5.00586",
    stroke: "#0E46C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsCircle);
export default __webpack_public_path__ + "static/media/chats-circle.aae806fc9dba37b5724f313c20e2d3ea.svg";
export { ForwardRef as ReactComponent };